import { i18n } from './index';

i18n.locale('en');
const t = (...args) => i18n.t(...args);

export { t };
